import Marquee from "react-fast-marquee";
import { SITE } from "../lib/siteConfig";
export default function EditorialMarquee() {
  return <section className="marquee-band relative" aria-label="PAAT services marquee" data-testid="marquee-section"><Marquee gradient={false} speed={38} pauseOnHover>{SITE.marquee.map((w, i) => <span key={i} className="marquee-word">{w}<span className="marquee-star">✦</span></span>)}</Marquee></section>;
}
